import format from "date-fns/format";

export const formattedPaymentDate = (date: string) =>
  date && format(new Date(date), "EEE d MMM");
